import { LayoutDashboard, UserPlus, Users, CalendarCheck, FileText, GraduationCap, UserCog, MessageSquare, UserCircle } from 'lucide-react';
import type { Group } from '@/components/layout/GroupedLayout';

/**
 * Desk officer menu, in the order of the front office's day:
 * admit → keep student records → run the day → results → teaching → staff → talk to people → me.
 * Each section is a dropdown, the same as the school owner's menu.
 */
export const deskGroups: Group[] = [
  { key: 'overview', section: 'Overview', icon: LayoutDashboard, items: [{ to: 'dashboard', label: 'Dashboard' }] },
  { key: 'admissions', section: 'Admissions', icon: UserPlus, items: [
    { to: 'admissions', label: 'Applications & admitting', also: ['applications', 'admit-exam-decide'] },
    { to: 'question-banks', label: 'Question banks (entrance exams)' },
  ] },
  { key: 'students', section: 'Students & families', icon: Users, items: [
    { to: 'students', label: 'Student directory', also: ['student', 'directory', 'student-profile'] },
    { to: 'families', label: 'Parents & families', also: ['parents', 'parents-families', 'guardians', 'parent-links'] },
    { to: 'logins', label: 'Logins & passwords' },
    { to: 'bulk-import', label: 'Bulk import', gate: 'students' },
    { to: 'classes', label: 'Classes' },
    { to: 'subject-registration', label: 'Subject registration' },
    { to: 'promotion', label: 'Promotion' },
    { to: 'graduation-alumni', label: 'Graduation & alumni' },
  ] },
  { key: 'day', section: 'Daily running', icon: CalendarCheck, items: [
    { to: 'attendance', label: 'Attendance' },
    { to: 'timetable', label: 'Timetable' },
    { to: 'calendar', label: 'Calendar & events' },
    { to: 'birthdays', label: 'Birthdays' },
  ] },
  { key: 'results', section: 'Results', icon: FileText, items: [
    { to: 'score-entry', label: 'Score entry' },
    { to: 'import-scores', label: 'Import scores (Excel)', gate: 'score-entry' },
    { to: 'score-locks', label: 'Score locks' },
    { to: 'result-approval', label: 'Result approval' },
    { to: 'broadsheet', label: 'Broadsheet' },
    { to: 'class-results', label: 'Class results & holds' },
    { to: 'held-results', label: 'Held results', gate: 'class-results' },
    { to: 'remarks', label: 'Principal remarks' },
    { to: 'publish-results', label: 'Publish results' },
    { to: 'transcript-requests', label: 'Transcript requests' },
    { to: 'reports', label: 'Reports' },
  ] },
  { key: 'teaching', section: 'Teaching', icon: GraduationCap, items: [
    { to: 'lessons', label: 'Lessons' },
    { to: 'live-classes', label: 'Live classes' },
    { to: 'lesson-notes', label: 'Lesson notes review' },
    { to: 'cbt-exams', label: 'CBT exams' },
  ] },
  { key: 'staff', section: 'Staff', icon: UserCog, items: [
    { to: 'staff', label: 'Staff, bank & salary' },
    { to: 'staff-attendance', label: 'Staff attendance & QR', also: ['clock-in-qr'] },
  ] },
  { key: 'comms', section: 'Communication', icon: MessageSquare, items: [
    { to: 'messages', label: 'Messages' },
    { to: 'notices', label: 'Notices & SMS', also: ['critical-alerts'] },
    { to: 'support', label: 'OJP support' },
  ] },
  { key: 'me', section: 'Me', icon: UserCircle, items: [
    { to: 'clock-in', label: 'Clock in (scan)' },
    { to: 'my-pay', label: 'My pay' },
    { to: 'notifications', label: 'Notifications' },
    { to: 'account', label: 'Account' },
  ] },
];
